import map from 'lodash/map'
import fill from 'lodash/fill'
import flatten from 'lodash/flatten'
import React, { useEffect } from 'react';
import { useFormikContext, FieldArrayRenderProps } from 'formik';
import styled from 'styled-components';

import * as api from '~/myApi'
import * as enums from '~/const/enums'

import Box from '@mui/material/Box';
import { Button } from '@mui/material';

import FormField from '~/component/form/FormField'

import TextField from '~/component/form/TextField'
import Switch from '~/component/form/Switch'
import RadioButtons from '~/component/form/RadioButtons'

import Answers from '~/component/surveyForm/Answers'

import DeleteIcon from '@mui/icons-material/Delete';

import { ErrorMessage } from '~/component/common/ErrorMessage';

import { FieldArray } from 'formik';

const QuestionsContainer = styled.div`
  padding: 0 8px 16px;
  background-color: #f5f5f5;
`;

const QuestionContainer = styled.div`
  margin: 8px 0 16px;
  overflow: hidden;
  position: relative;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  border: 2px solid #ccc;
  background-color: #fff;
`;
const QuestionTitle = styled.h2`
  background-color: #eee;
  margin: 0 0 16px;
  padding: 16px 0;
  font-size: 14px;
  text-align: center;
  color: #333;
`;
const DeleteButton = styled(Button)`
  position: absolute;
  top: 8px;
  right: 8px;
`;

interface FormFieldProps {
  value?: api.TypesQuestion[];
  error?: string
}

const MAX_QUESTIONS_NUM = 6

export const Questions: React.FC<FormFieldProps> = (props) => {
  return (
    <FieldArray
      name="questions"
      render={(arrayHelpers) => {
        return (
          <QuestionsContainer>
            {props.value?.map((question, i) => {
              const name = `questions[${i}]`;
              return (
                <Question key={i} {...{
                  name,
                  question,
                  i,
                  arrayHelpers,
                  hasDeleteButton: props.value?.length !== 1
                }} />
              );
            })}

            {/* {props.value?.length! < MAX_QUESTIONS_NUM && (
              <Box sx={{ textAlign: 'center' }}>
                <Button variant="outlined" onClick={() => arrayHelpers.push({
                  text: '',
                  random: false,
                  answers: flatten(map(fill<api.TypesAnswer>(Array(4), {
                    text: '',
                    fixOrder: false,
                    exclusive: false,
                    lift: '0'
                  }), (a, j) => Object.assign({}, a, { order: j })))
                })}>
                  + 設問を追加
                </Button>
              </Box>
            )} */}

            <ErrorMessage>{props.error}</ErrorMessage>
          </QuestionsContainer>
        );
      }}
    />
  )
}

interface QuestionProps {
  name: string
  question: api.TypesQuestion
  i: number
  arrayHelpers: FieldArrayRenderProps
  hasDeleteButton: boolean
}

export const Question: React.FC<QuestionProps> = (props) => {
  const { setFieldValue } = useFormikContext()
  const { name, question, i } = props
  useEffect(() => {
  }, [])

  return (
    <QuestionContainer key={i}>
      <QuestionTitle>設問 {i + 1}</QuestionTitle>
      <FormField label="設問テキスト" required>
        <TextField {...{
          name: `${name}.text`,
          type: 'string',
          value: question.text,
        }} />
      </FormField>
      <FormField label="設問種別">
        <TextField {...{
          name: `${name}.kind`,
          type: 'string',
          value: question.kind,
        }} />
      </FormField>
      <FormField label="タイプ">
        <RadioButtons {...{
          name: `${name}.type`,
          items: enums.QUESTION_TYPE,
          value: question.type,
        }} />
      </FormField>
      <FormField label="ランダム並び替え">
        <Switch {...{
          name: `${name}.random`,
          value: question?.random,
        }} />
      </FormField>

      <FormField label="回答">
        <Answers {...{
          value: question.answers,
          hasFixOrderSwitch: question?.random,
          hasExclusiveSwitch: question?.type === api.EnumsQuestionType.QUESTION_TYPE_MULTI_ANSWER,
          index: i 
        }} />
      </FormField>

      {props.hasDeleteButton && (
        <DeleteButton
          color="error"
          startIcon={<DeleteIcon />}
          onClick={() => props.arrayHelpers.remove(i)}
        >
          削除
        </DeleteButton>
      )}

    </QuestionContainer>
  )
}

export default Questions